// extracted by mini-css-extract-plugin
export var dateLabel = "_2q-0";
export var dateLabelError = "_2q-1";
export var fullWidth = "_2q-2";
export var smaller = "_2q-3";